import { render, staticRenderFns } from "./subNavigation.vue?vue&type=template&id=90de747c&scoped=true&"
import script from "./subNavigation.vue?vue&type=script&lang=js&"
export * from "./subNavigation.vue?vue&type=script&lang=js&"
import style0 from "./subNavigation.vue?vue&type=style&index=0&id=90de747c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90de747c",
  null
  
)

export default component.exports